import { AudioPlaylistEntry, RenderablePlaylistEntry } from "../interfaces/playlist";

export enum PlayerStateFields {
  playlist = "playlist",
  audioPlaylist = "audioPlaylist",
  fullscreen = "fullscreen",
  currentTime = "currentTime",
  lastTime = "lastTime",
  paused = "paused",
  playerVolume = "playerVolume",
  playAudioPlaylist = "playAudioPlaylist",
  muted = "muted",
  previousIndex = "previousIndex",
  currentIndex = "currentIndex",
  nextIndex = "nextIndex",
  triggered = "triggered",
  focused = "focused",
  fullscreenElement = "fullscreenElement",
}

export type PlayerState = {
  playlist: RenderablePlaylistEntry[];
  audioPlaylist: AudioPlaylistEntry[];
  fullscreen: boolean;
  currentTime: number;
  lastTime: number;
  playerVolume: number;
  playAudioPlaylist: boolean;
  paused: boolean;
  muted: boolean;
  previousIndex: number;
  currentIndex: number;
  nextIndex: number;
  triggered: boolean;
  focused: boolean;
  fullscreenElement: HTMLElement;
};
